import React from 'react'
import PropTypes from 'prop-types'
import { Avatar } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'

// ----------------------------------------------------------------------

MyAvatar.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'error',
    'info',
    'success',
    'warning',
    'default',
    'inherit',
    // add more if your theme supports
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
}

const AVATAR_SIZES = {
  small: 32,
  medium: 40,
  large: 56,
}

const useStyles = makeStyles(theme => ({
  smallAvatar: ({ color, theme, size }) => {
    let bgColor = theme.palette.primary.main
    let textColor = 'white'
    if (color && color !== 'primary') {
      bgColor = color === 'gray' ? 'rgb(244, 246, 248)' : bgColor
      textColor = theme.palette[color]?.contrastText || textColor
    }
    const avatarSize = AVATAR_SIZES[size] || AVATAR_SIZES.medium
    return {
      width: avatarSize,
      height: avatarSize,
      padding: theme.spacing(1),
      textTransform: 'uppercase',
      backgroundColor: bgColor,
      color: textColor,
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      fontSize: size === 'small' ? 13 : undefined,
    }
  },
}))

function MyAvatar(props) {
  const { text, color = 'primary', className, size = 'medium' } = props
  const theme = useTheme()
  const classes = useStyles({ color, theme, size })

  return (
    <Avatar
      className={classes.smallAvatar + (className ? ` ${className}` : '')}
    >
      {text}
    </Avatar>
  )
}

export default MyAvatar
